export let NavigationMenuPopupCssVars = /*#__PURE__*/function (NavigationMenuPopupCssVars) {
  /**
   * The fixed width of the popup element.
   * @type {number}
   */
  NavigationMenuPopupCssVars["popupWidth"] = "--popup-width";
  /**
   * The fixed height of the popup element.
   * @type {number}
   */
  NavigationMenuPopupCssVars["popupHeight"] = "--popup-height";
  return NavigationMenuPopupCssVars;
}({});